import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 34, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.75, delay, ease: [0.16, 1, 0.3, 1] }}
  >
    {children}
  </motion.div>
);

export const SectionHeader = ({ eyebrow, children, copy, align = "center" }) => (
  <Reveal
    className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""} mb-16 md:mb-24`}
  >
    {eyebrow && <div className="eyebrow-label mb-5">{eyebrow}</div>}
    <h2 className="headline text-4xl sm:text-5xl lg:text-6xl mb-5">{children}</h2>
    {copy && <p className="text-white/55 text-sm md:text-base leading-relaxed">{copy}</p>}
  </Reveal>
);

export default Reveal;
